import api from '../api/instance';
 
import { UserPreference } from '../models/user-preferences.model';
import { useQuery } from 'react-query';
import { PrivateURLConstants } from '@constants/private-url.constant';

const nameSpace = PrivateURLConstants.USER_PREFERENCES;
const show = (userId: number) => {
  return api
    .get<UserPreference>(nameSpace + '/' + userId)
    .then((data) => new UserPreference().deserialize(data))
    .catch((e) => Promise.reject(e));
};

const save = (userPreference: UserPreference) => {
  return api
    .put<UserPreference>(
      nameSpace + '/' + userPreference.userId,
      userPreference.serialize(),
    )
    .then((data) => new UserPreference().deserialize(data))
    .catch((e) => Promise.reject(e));
};
const UserPreferenceService = {
  show,
  save,
};

export const showUserPreferenceService = (userId: number) => {
  return useQuery('show-userpreference', async () => {
    const response = await api.get<UserPreference>(
      nameSpace + '/' + userId,
      {},
    );
    return new UserPreference().deserialize(response);
  });
};

export default UserPreferenceService;
